const setCollectionDocumentWithId = async (collectionRef, id, data) => {
  await collectionRef.doc(id).set(data);
};
export default setCollectionDocumentWithId;
